export const NOTIFICATION_TYPES = {
  // Attendee notifications
  EVENT_RSVP_CONFIRMATION: 'event_rsvp_confirmation',
  EVENT_STARTING_SOON_ATTENDEE: 'event_starting_soon_attendee',
  EVENT_FEEDBACK_REQUEST: 'event_feedback_request',
  EVENT_CANCELLED_ATTENDEE: 'event_cancelled_attendee',

  // Organization Leader notifications
  EVENT_SUBMISSION: 'event_submission',
  EVENT_APPROVED_LEADER: 'event_approved_leader',
  EVENT_CANCELLED_LEADER: 'event_cancelled_leader',
  EVENT_STARTING_SOON_LEADER: 'event_starting_soon_leader',
  EVENT_DENIED_LEADER: 'event_denied_leader',
  EVENT_EXPIRED_LEADER: 'event_expired_leader',

  // Approver notifications
  EVENT_PENDING_APPROVAL_APPROVER: 'event_pending_approval_approver',
  EVENT_CANCELLED_APPROVER: 'event_cancelled_approver',

  // Admin notifications
  EVENT_PENDING_APPROVAL: 'event_pending_approval',
  EVENT_CANCELLED_ADMIN: 'event_cancelled_admin',
  EVENT_STARTING_SOON_ADMIN: 'event_starting_soon_admin',
  ORG_LEADER_REQUEST: 'org_leader_request',
  ORG_MEMBERSHIP_SETTING_CHANGED: 'org_membership_setting_changed',

  // Executive Admin notifications
  ORG_LEADER_REQUEST_EXEC: 'org_leader_request_exec',
  ADMIN_REQUEST: 'admin_request',

  // Follower notifications
  EVENT_APPROVED_USER: 'event_approved_user',

  // General notifications
  EVENT_TIME_LOCATION_UPDATED: 'event_time_location_updated',
  EVENT_REJECTED: 'event_rejected',

  // Cron notifications
  CRON_WEEKLY_UPCOMING_EVENTS: 'cron_weekly_upcoming_events',
  CRON_DAILY_PENDING_EVENTS: 'cron_daily_pending_events',
  CRON_EVENT_START_IN_ONE_HOUR: 'cron_event_start_in_one_hour',
  CRON_EVENT_TIME_TO_CHECK_IN: 'cron_event_time_to_check_in',
} as const;

export type NotificationType = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];

